import { useState, useEffect } from "react"
import { Loader2, ChevronDown, TriangleAlert } from "lucide-react"

interface DetailAccordionProps {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
  forceOpen?: boolean | null
  loading?: boolean
  error?: boolean
  icon?: React.ReactNode
  summary?: React.ReactNode
}

export const DetailAccordion = ({
  title,
  children,
  defaultOpen = false,
  forceOpen,
  loading,
  error,
  icon,
  summary,
}: DetailAccordionProps) => {
  const [localOpen, setLocalOpen] = useState(defaultOpen)

  useEffect(() => {
    if (forceOpen != null) setLocalOpen(forceOpen)
  }, [forceOpen])

  return (
    <div className="overflow-hidden border-b border-gray-100 last:border-b-0">
      <button
        onClick={() => !loading && setLocalOpen((prev) => !prev)}
        disabled={loading}
        className={`flex items-center w-full px-3 py-2 text-base font-medium text-gray-700 transition-colors min-h-9 ${
          loading ? "pointer-events-none opacity-60" : "cursor-pointer hover:bg-gray-50/50"
        }`}
      >
        <span className="flex items-center gap-1.5 shrink-0 text-primary-light">{icon}</span>
        <span className="ml-1.5 truncate" title={title}>
          {title}
        </span>
        <span className="flex items-center gap-1.5 ml-auto">
          {summary && !loading && !error && (
            <span className="text-sm text-gray-600 font-medium text-right truncate max-w-[140px]">{summary}</span>
          )}
          {loading ? (
            <Loader2 className="w-3.5 h-3.5 animate-spin" />
          ) : error ? (
            <TriangleAlert className="w-4 h-4 text-error" />
          ) : (
            <ChevronDown
              className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${localOpen ? "rotate-180" : ""}`}
            />
          )}
        </span>
      </button>
      <div className={`accordion-grid ${localOpen ? "open" : ""}`}>
        <div>{localOpen && <div className="px-3 pb-3 pt-1">{children}</div>}</div>
      </div>
    </div>
  )
}
